import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useSuccessSnack, useErrorSnack } from '../utils/snackbar';
import i18n from '../i18n';

import { get, post } from '../utils/api';

async function setNPS({ key, trackingKey, rating, comment }) {
  const res = await post(`/nps/set`, {
    key,
    trackingKey,
    rating,
    comment,
  });
  return res?.data;
}

async function checkNPS({ key }) {
  try {
    const res = await get(`/nps/check?key=${key}`);
    return res?.data;
  } catch (err) {
    return null;
  }
}

export function useNPSQuery(key) {
  const { data, isLoading } = useQuery(['nps', key], () => checkNPS({ key }));

  return {
    nps: data,
    isLoading,
  };
}

export function useNPSActions() {
  const queryClient = useQueryClient();

  const {
    mutate: _setNPS,
    mutateAsync: setNPSAsync,
    isSuccess,
    isError,
  } = useMutation(
    ({ key, rating, comment, trackingKey }) =>
      setNPS({ key, rating, comment, trackingKey }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('nps');
      },
    }
  );

  useSuccessSnack(i18n.t('Tack för din feedback'), isSuccess);
  useErrorSnack(i18n.t('Kunde inte spara din feedback'), isError);

  return {
    setNPS: _setNPS,
    setNPSAsync,
    isSetNPSSuccess: isSuccess,
    isSetNPSError: isError,
  };
}
